import {
  IonButton,
  IonContent,
  IonPopover,
} from "@ionic/react";
import React, { useState } from "react";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";
import MonthYearRequestBtn from "./MonthYearRequestBtn";

interface Props {
  id: string;
  name: string;
}

async function downloadInvoice(
  token: string,
  id: string,
  month: number,
  year: number,
  numMonths?:number
) {
  return fetch(`${API_URL}/8020-invoice`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      building: id,
      month: month,
      year: year,
      num_months:numMonths
    }),
  }).then(async (res: any) => {
    if (res.ok) {
      return res.blob();
    } else {
      const data = await res.json();
      return {
        error: data.error,
      };
    }
  });
}

const Download8020InvoiceButton: React.FC<Props> = ({ id, name }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async (month:number,year:number,numMonths?:number) => {
    setLoading(true);
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const res = await downloadInvoice(token, id, month, year, numMonths);
    if ("error" in res) {
      NotificationPopUp("error", res["error"], "Error Generating Invoice");
    } else {
      const url = window.URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}_${month}_${year}_Invoice.docx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode!.removeChild(link);
    }
    setLoading(false);
  };

  return (
    <div>
      <IonButton
        id="download-8020-invoice"
        fill="solid"
        className="default-btn-size"
        color="medium"
        style={{margin:'0.25rem'}}
      >
        80/20 Invoice
      </IonButton>
      <IonPopover
        trigger="download-8020-invoice"
        size="auto"
        side="bottom"
        alignment="start"
        // showBackdrop={false}
      >
        <IonContent color="medium" style={{ padding: "1rem" }}>          
          <MonthYearRequestBtn handleRequest={handleDownload} loading={loading} monthsRequired={true}/>
        </IonContent>
      </IonPopover>
    </div>
  );
};

export default Download8020InvoiceButton;
